import { createAppUseApiHook } from '@hwm/ui-lib/core/http';
import { httpClient } from './httpClient';

export const useApi = createAppUseApiHook(httpClient);
